export function fromSubdomain(subdomain: string): boolean {
  const hostname = window.location.hostname;
  const currentSubdomain = hostname.split('.')[0];
  return currentSubdomain.startsWith(subdomain);
}
